import { render, staticRenderFns } from "./FileViewWrap.vue?vue&type=template&id=264b5bc7&scoped=true&"
import script from "./FileViewWrap.vue?vue&type=script&lang=js&"
export * from "./FileViewWrap.vue?vue&type=script&lang=js&"
import style0 from "./FileViewWrap.vue?vue&type=style&index=0&id=264b5bc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264b5bc7",
  null
  
)

export default component.exports